import { CacheKeys } from '@headless-workspace/config';
import { ResultServerActionType } from '@headless-workspace/core-domain';
import { mutate } from 'swr';
import { CustomerBasketValue, StoreInfoValue, UserInfo, WishlistEntity } from '../../../server';

type CacheKeysRevalidationReturnType = {
    [CacheKeys.User]: UserInfo | undefined;
    [CacheKeys.FavoriteStore]: StoreInfoValue | undefined;
    [CacheKeys.Wishlist]: WishlistEntity | undefined;
    [CacheKeys.Basket]: CustomerBasketValue | undefined;
};

export function mutateWithDataIfSuccess<K extends keyof CacheKeysRevalidationReturnType>(
    key: K,
    data?: ResultServerActionType<CacheKeysRevalidationReturnType[K]>,
) {
    if (data && (data.type === 'success' || data.type === 'empty')) {
        void mutate(key, data, {
            revalidate: false,
        });
    } else {
        void mutate(key);
    }
}
